import { MotivationGroupEvaluated } from "tm-shared/types";

import { KPI_ICONS } from "@/domains/kpi";

export const deriveKPIMetadata = (
    evaluatedMotivationGroup: MotivationGroupEvaluated,
) => {
    const group = evaluatedMotivationGroup.group;
    const {
        groupType,
        name,
        compensation: { maxComplete },
        motivationType,
        finGroupDetails,
        salaryPercent,
        planGrowthCoefficient,
    } = group;

    const {
        statistic: { fact: factCount, plan: planCount, percent },
    } = evaluatedMotivationGroup.evaluation;

    const bonus = evaluatedMotivationGroup.evaluation.bonus;
    const compensation = evaluatedMotivationGroup.group.compensation;
    const progressive =
        "scales" in compensation ? compensation.scales : undefined;
    const minComplete =
        "minComplete" in compensation ? compensation.minComplete : undefined;

    const isDropout = motivationType === "s";
    const isProgressive = (progressive?.length ?? 0) > 0;
    const maxPercent = isProgressive ? progressive?.[0]?.from : minComplete;
    const isTargetReached = percent >= (maxPercent ?? 0);
    const Icon = KPI_ICONS[motivationType];

    return {
        group,
        groupType,
        name,
        motivationType,
        finGroupDetails,
        salaryPercent,
        planGrowthCoefficient,
        factCount,
        planCount,
        percent,
        bonus,
        progressive,
        minComplete,
        maxComplete,
        isDropout,
        isProgressive,
        maxPercent,
        isTargetReached,
        Icon,
    };
};

export type KPIMetadata = ReturnType<typeof deriveKPIMetadata>;
